export default {
  active: false,
  activeProfileId: '',
  agreementsShown: false,
  authToken: undefined,
  authTokenInterval: undefined,
  bssId: '',
  crossBorderVerified: false,
  email: '',
  forceChangePassword: false,
  httpSession: {},
  id: '',
  ipressoId: '',
  ipressoMonitoringPixel: '',
  msisdn: '',
  profiles: [],
  roles: [],
  ssoUser: undefined,
  status: {},
  subscriberStatus: '',
  tenant: '',
  gender: '',
  dateOfBirth: '',
};
